import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { HttpService } from '../../services/http/http.service';
import { CommunicationService } from '../../services/communication/communication.service';
import { LoaderService } from '../../services/loader/loader.service';
import { FADE_IN } from '../../util/animations/animation';
import { ToastrService } from 'ngx-toastr';
import { HelperService } from '../../util/helper/helper.service';
import { MatDialog } from "@angular/material/dialog";
import { DownloadService } from '../services/download.service';
import { AngularFirestore } from '@angular/fire/firestore';
import { AngularFireAuth } from '@angular/fire/auth';
import { UploadDocumentsComponent } from '../../shared/component/upload-documents/upload-documents.component';
import { forkJoin } from 'rxjs';
import * as mime from 'mime';
/**
 * These are the list of documents provided the patient at the time of taking a survey, CareAlly can download the documents by clicking on the image.
 */
@Component({
  selector: 'app-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.scss'],
  animations: [FADE_IN]
})
export class DocumentsComponent implements OnInit {
  @Input() patientId: any = '';
  @Input() patientDetails: any = {};
  @Input() isTabActivated: boolean;
  @Output() public count = new EventEmitter();
  endpoints = [];
  documents:any = [];
  downloadedDocuments = [];
  isFirstCall = true;
  mediaListener;
  fileType = [
    {name: 'image', src: '', type: 'png jpg jpeg tif gif'},
    {name: 'pdf', src: 'assets/images/documents/pdf.png', type: 'pdf'},
    {name: 'doc', src: 'assets/images/documents/doc.png', type: 'doc docx'},
    {name: 'excel', src: 'assets/images/documents/excel.png', type: 'xls xlsb xlsm xlsx csv'}
  ]

  isShowSkeleton = false;

  constructor(
    private httpService: HttpService,
    private loader: LoaderService,
    private toastr: ToastrService,
    private afs: AngularFirestore,
    private helper: HelperService,
    public auth: AngularFireAuth,
    public dialog: MatDialog,
    private communicationService: CommunicationService,
    private downloadService: DownloadService
  ) {
    this.communicationService.loadMedia.subscribe(media=>{
      if(media)
        this.getImages();
    })
    this.communicationService.getTemplateData.subscribe(data=>{
      this.downloadedDocuments = data.allDocuments || [];
    })
   }

  ngOnInit(): void {
    this.getDocumentLists();
  }
  
/**
 * Fetch the media from firebase and create endpoint array to call the parallel API calls.
 */
  getDocumentLists(){
    this.loader.show('progress');
    this.auth.authState.subscribe(res =>{
      if(res)
        this.mediaListener = this.afs.collection('Media', ref => ref.where('subject.reference', '==', `Patient/${this.patientId}`)).valueChanges().subscribe(response=>{
          if(this.downloadedDocuments.length)
            response = response.length&&response.filter((x:any)=> this.downloadedDocuments.findIndex(y=> y.id === x.id ) === -1) || []
          
          this.documents = [...this.downloadedDocuments,...response];
          this.endpoints = [];
          this.count.emit(this.documents.length);
          this.documents.map(x=>{
            const ext = mime.getExtension(x.content.contentType);
            const index = this.fileType.findIndex(y=> y.type.includes(ext));
            if(index !== -1){
              x.type = this.fileType[index].name;
              if(this.fileType[index].name === 'image'){
                if(!x.src)
                  this.endpoints.push(this.httpService.get(`media/${x.id}`));
              }else{
                x.src = this.fileType[index].src;
              }
            }else{
              x.src = "assets/images/documents/doc.png";
            }
          })
          
          // Call this when document is uploaded
          if(this.downloadedDocuments.length || !this.isFirstCall){
            this.getImages();
          }
          this.isFirstCall = false;

          this.loader.hide('progress');
          this.isShowSkeleton = false;
          if(!this.documents.length){ // set print template data to null
            this.communicationService.setTemplateData(null, 'allDocuments'); 
            this.communicationService.setTemplateData(null, 'documents'); 
          }
          else{
            this.communicationService.setTemplateData([], 'allDocuments');
            this.communicationService.setTemplateData([], 'documents');  
          }
        });
      })
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes.isTabActivated&&changes.isTabActivated.currentValue)
      this.communicationService.isLoadMedia(true);
      // this.getImages();
  }

  /**
   * Get the images from the backend based on media id, it does the parallel API call
   */
  getImages(){
    if(this.endpoints.length){
      this.isShowSkeleton = true;
      forkJoin(this.endpoints).subscribe((results: any) => {
        results.map(x=>{
          const index = this.documents.findIndex(y=> y.id===x.id);
          if(index !==-1 ){
            this.documents[index].content = x.content;
            this.documents[index].src =`data:${x.content.contentType};base64,${x.content.data}`;
          } 
            this.endpoints = [];
            this.isShowSkeleton = false;
        })
        this.communicationService.setTemplateData(this.documents, 'allDocuments'); 
        this.communicationService.setTemplateData(this.documents, 'documents'); 
      },error =>{
        this.loader.hide('progress');
        this.toastr.warning(error, 'Documents', {
          progressBar: true, timeOut: 3000
        });
        this.isShowSkeleton = false;
      });
    }  
  }

  /**
   * This function is used to get the media and sends the data to download service
   * @param data 
   */
  getMedia(data){
    this.loader.show('progress');
    this.httpService.get(`media/${data.id}`)
      .subscribe((response: any) => {
        this.loader.hide('progress');
        this.downloadService.downloadFile(response.content, this.patientDetails);
      }, error =>{
        this.loader.hide('progress');
        this.toastr.warning(error, 'Patients', {
          progressBar: true, timeOut: 3000
        });
      })
  }

  /**
   * This fucntion is used to display the image in UI from base64 data
   * @param base64Image 
   */
  transform(base64Image){
    return this.helper.transform(base64Image);
  }

  openUploadMediaPopup() {
    this.dialog.open(UploadDocumentsComponent, {
      width: "600px",
      disableClose: true,
      panelClass: 'custom-dialog-container',
      data: { 
        patientId: this.patientId
      }
    });
  }

  ngOnDestroy(): void {
    this.mediaListener.unsubscribe();
  }

}
